import { useFormContext } from '@sravni/cosago-react-library/lib/hooks';
import { useCallback, useEffect } from 'react';

import type { TPassportFormFields } from 'entities/creditForm';
import { useGetLocationSettlement } from 'entities/creditForm';

export const useResidenceLocationRouteLoader = () => {
  const { watch, setValue } = useFormContext<TPassportFormFields>();
  const [loadLocationSettlement, { data }] = useGetLocationSettlement();
  const residenceAddress = watch('residenceAddress');

  const getLocationSettlement = useCallback(
    async (address: string) => {
      loadLocationSettlement(address, true);
    },
    [loadLocationSettlement],
  );

  useEffect(() => {
    if (data) {
      setValue('residenceLocationRoute', data.route || '');
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [data]);

  useEffect(() => {
    if (residenceAddress?.value && (residenceAddress?.data as unknown as { type: 'manual' })?.type !== 'manual') {
      getLocationSettlement(String(residenceAddress.value));
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [residenceAddress?.value]);
};
